export default __webpack_public_path__ + "static/media/employees_blank.aa1a0e0d.png";